<template>
    <div class="notice bg_fff">
        <v-title title="远程教育">
            <span class="color_main flex1 fs14 tar pr30 pointer">查看更多课程</span>
        </v-title>
        <div class="pl15 pr15 pt15 pb15 fs14">
            <ul>
                <li v-for="(item,index) in 3" class="" :class="[index>0?'mt15':'']">
                    <div class="h4 color_333">
                        <span class="fs14">明天</span>
                        <span class="fs12 ml10">直播名称</span>
                    </div>
                    <div class="flex mt5 aic">
                        <div class="app_btn_main">直播</div>
                        <div class="ml15 color_999 fs12">
                            江小白    主任医师   |    肿瘤外科
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import {timeFormat} from "../../lib/utils";
  import VTitle from "../common/v-title";

  export default {
    name: 'home-ycjy',
    data() {
      return {};
    },
    computed: {},
    components: {VTitle},
    mixins: [],
    created() {

    },
    mounted() {
      setTimeout(this.getData, 2000);
    },
    beforeDestroy() {

    },
    methods: {
    }
  }
</script>

<style scoped>
    .main {
        height: 200px;
    }

    .main >>> .echarts {
        width: 100%;
        height: 100%;
    }
</style>
